import { ContextData } from "@/API"
import { GetEmbeddingCollectionDataUrl } from "@/APIURL"
import { Text, Button, Divider } from "@mantine/core"

export function EmbeddingContextDataPage(props: { workspaceId: string, data: ContextData }) {
    return <>
        <Button variant="light" size="compact-sm" onClick={() => {
            window.open(GetEmbeddingCollectionDataUrl(props.workspaceId, props.data.collectionId, props.data.dataId), '_blank')
        }}>開啟</Button>
        <Text size="lg">DataId</Text>
        <Text >{props.data.dataId}</Text>
        <Text size="lg">相似度</Text>
        <Text >{props.data.score}</Text>
        {props.data.searchText && <>
            <Text size="lg">搜尋目標</Text>
            <Text c="gray" style={{ whiteSpace: "pre-wrap" }}>{props.data.searchText}</Text>
        </>}
        <Text size="lg">資料</Text>
        <Text c="gray" style={{ whiteSpace: "pre-wrap" }}>{props.data.text}</Text>
        <Divider my="md" />
    </>
}